import React, { useState, useEffect, } from "react";
import { FormattedMessage, useIntl, } from "react-intl";
import Spinner from "../../../components/Spinner";
import { useNavigate, } from 'react-router';
import { useForm, Controller, } from "react-hook-form";
import { Row, Card, Button, Col, Descriptions, Form, Switch, } from 'antd';
import notification from '../../../services/notification';
import { UserDetails, UserUpdate, } from '../../../services/users';
import { PenIcon, CheckSquareIcon, InfoIcon, } from "@phosphor-icons/react";

const ProfileSettingsView = ({
    ...props
}) => {

    const [userProfileData, setUserProfileData] = useState(undefined);
    const [detailsLoading, setDetailsLoading] = useState(true);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [formDisabled, setFormDisabled] = useState(true);

    const history = useNavigate();
    const customerID = "me";
    // const localdata = sessionStorage.getItem('authentication');
    // const LocalStore = JSON.parse(localdata || '{}');
    const settingsForm = useForm({ mode: "all" });
    const intl = useIntl();

    useEffect(() => {
        if (userProfileData) {
            settingsForm.reset({
                trading_strategy_disabled: userProfileData.user_system_settings.trading_strategy_disabled ?? false,
            });
            setDetailsLoading(false);
        }
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfileData]);

    useEffect(() => {
        loadProfileDetails();

        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadProfileDetails = () => {
        setDetailsLoading(true);

        // get the user profile details
        UserDetails({ user_id: customerID }, history)
            .then(response => {
                if (response.status) {
                    setUserProfileData(response.data);

                } else {
                    history('/dashboard');
                    console.error('error:', response)
                    notification['warning']({
                        message: 'User details',
                        description: "Error on requesting profile settings data",
                    });
                }
            })
            .catch(error => {
                console.error('error: ', error);
            });
    };

    const updateSystemSettingsInLocalStore = (data) => {
        const localdata = sessionStorage.getItem('authentication');
        const LocalStore = JSON.parse(localdata || '{}');

        // update user_system_settings in local store
        LocalStore.user_system_settings = data;
        sessionStorage.setItem('authentication', JSON.stringify(LocalStore));
    };

    const saveSettings = (data) => {
        setButtonDisabled(true);
        const payload = {
            user_id: 'me',
            user_first_name: userProfileData.user_data.user_first_name,
            user_last_name: userProfileData.user_data.user_last_name,
            user_language: userProfileData.user_data.user_language,
            user_system_settings: { ...data },
        };

        UserUpdate(payload)
            .then(response => {
                if (response.status) {
                    updateSystemSettingsInLocalStore(payload.user_system_settings);
                    notification['success']({
                        message: 'User settings',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                } else {
                    notification['error']({
                        message: 'User settings',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                }
                setButtonDisabled(false);
                setFormDisabled(true);
                loadProfileDetails();
            })
            .catch(error => {
                console.error('error: ', error);
                setButtonDisabled(false);
                notification['error']({
                    message: 'User settings',
                    description: intl.formatMessage({ id: "UNKNOWN_ERROR" }),
                });
            });
    };

    const editSettings = () => {
        setFormDisabled(!formDisabled);
    };

    return (
        <React.Fragment >

            <Row gutter={[32, 32]}>
                <Col span={24}>

                    {/* Profile basic card */}
                    {detailsLoading && (<Spinner />)}

                    {!detailsLoading && (
                        <Card
                            title={<h4 className="card-title"><FormattedMessage id="profile-user-settings" /></h4>}
                            className="my-4"
                            extra={[
                                <React.Fragment key="0">
                                    {formDisabled ? (
                                        <Button
                                            onClick={() => { editSettings() }}
                                            icon={<PenIcon size={16} weight="light" />}>
                                            <FormattedMessage id="settings-edit" />
                                        </Button>
                                    ) : (
                                        <Button
                                            disabled={buttonDisabled}
                                            loading={buttonDisabled}
                                            onClick={settingsForm.handleSubmit(saveSettings)}
                                            className="ant-btn-success">
                                            {!buttonDisabled && <CheckSquareIcon size={16} weight="light" className="mr-1" />}
                                            <FormattedMessage id="settings-save" />
                                        </Button>
                                    )}
                                </React.Fragment>
                            ]}>

                            {/* User system settings */}
                            <Descriptions bordered column={1}>
                                <Descriptions.Item label={<FormattedMessage id="trading-strategy-disabled" />}>
                                    <Controller
                                        control={settingsForm.control}
                                        name="trading_strategy_disabled"
                                        defaultValue={false}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                labelCol={{ span: 24 }}
                                                wrapperCol={{ span: 24 }}>
                                                <Switch
                                                    onChange={onChange}
                                                    checked={value}
                                                    disabled={formDisabled}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                    {!formDisabled && (
                                        <small className="form-text text-muted"><InfoIcon size={14} weight="light" /> <FormattedMessage id="trading-strategy-disabled-tt" /></small>
                                    )}
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                    )}

                </Col>
            </Row>

        </React.Fragment>
    );
};

export default ProfileSettingsView;